import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './Button.css';


const TopLinkButton = ({label, url}) => {   

    let isUrlExternal = url.includes("http://") || url.includes("https://");

    return (
      <div>
        {isUrlExternal && (<a href={url} className="top-nav-button button no-print red pointer-edit">{label}</a>)}
        {!isUrlExternal && (<Link to={url} className="top-nav-button button no-print red pointer-edit">{label}</Link>)}
      </div>
    
      );
};

TopLinkButton.propTypes = {
  label: PropTypes.string,
  url : PropTypes.string
};
 
export default TopLinkButton;
